export const generatePermissions = (
  modulePermissionArray: any[],
  permissionConstants: Record<string, string>
) => {
  const permissions: Record<string, boolean> = {};

  Object.keys(permissionConstants).forEach((key) => {
    permissions[key] = false;
  });

  modulePermissionArray.forEach(
    ({ parentModuleIndex, moduleIndex, permissionIndex }) => {
      let key: string;
      // Nếu parentModuleIndex === moduleIndex, đó là parent module (2 phần)
      // Nếu khác nhau, đó là child module (3 phần)
      if (parentModuleIndex === moduleIndex) {
        key = `${parentModuleIndex}-${permissionIndex}`;
      } else {
        key = `${parentModuleIndex}-${moduleIndex}-${permissionIndex}`;
      }
      if (Object.prototype.hasOwnProperty.call(permissions, key)) {
        permissions[key] = true;
      }
    }
  );

  return permissions;
};
